export const EMAIL_RECIPIENT = 'burhan@iyelo.com';
